module.exports = __webpack_public_path__ + "img/upload.4b1d826c.svg";